export default __webpack_public_path__ + "static/media/eatingtimes_3@3x.04af63fe.jpg";